import { ArrowLeft, MessageCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const SAFARI_HERO = 'https://images.unsplash.com/photo-1516426122078-c23e76319801';

const SA_IMAGE_1 = 'https://images.unsplash.com/photo-1554990772-0bea55d510d5';
const SA_IMAGE_2 = 'https://images.pexels.com/photos/34780131/pexels-photo-34780131.jpeg';
const SA_IMAGE_3 = 'https://images.unsplash.com/photo-1516026672322-bc52d61a55d5';

const TZ_IMAGE_1 = 'https://images.unsplash.com/photo-1564101160531-4838e8a5f4e7';
const TZ_IMAGE_2 = 'https://images.unsplash.com/photo-1528732533941-ffd7083d5dfe';
const TZ_IMAGE_3 = 'https://images.pexels.com/photos/10495959/pexels-photo-10495959.jpeg';

const WHATSAPP_URL = 'https://wa.me/5548991904829?text=' + encodeURIComponent('Olá! Gostaria de conhecer mais sobre os safaris exclusivos da JM Travel. Pode me ajudar?');

export default function Safari() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Header />
      <div className="relative h-96 bg-cover bg-center flex items-center justify-center" style={{ backgroundImage: `url('${SAFARI_HERO}')` }}>
        <div className="absolute inset-0 bg-black/50"></div>
        <div className="relative z-10 container text-white text-center">
          <button onClick={() => navigate('/')} className="inline-flex items-center gap-2 mb-6 hover:opacity-80 transition-opacity mx-auto border-2 border-white rounded-full px-6 py-2 text-base font-semibold">
            <ArrowLeft size={20} />
            Voltar
          </button>
          <h1 className="text-5xl md:text-6xl font-bold mb-4 text-white">SAFARIS EXCLUSIVOS</h1>
          <p className="text-xl text-white/90">Experiências inesquecíveis na savana africana</p>
        </div>
      </div>

      <div className="container py-16 flex-1">
        <section className="mb-16 space-y-6 max-w-3xl mx-auto">
          <p className="text-lg text-muted-foreground leading-relaxed">Imagine acordar com o nascer do sol na savana africana, cercado pela natureza mais selvagem do mundo.</p>
          <p className="text-lg text-muted-foreground leading-relaxed">No safari, cada dia é único: você pode ver leões, elefantes, girafas e até os famosos Big Five bem de perto, sempre com guias experientes que tornam tudo ainda mais especial.</p>
          <p className="text-lg text-muted-foreground leading-relaxed">São dois safáris por dia (manhã e pôr do sol), exatamente nos melhores horários para viver momentos que parecem de filme daqueles que você nunca esquece.</p>
          <p className="text-lg text-muted-foreground leading-relaxed">E o melhor: organizamos tudo pra você, com conforto, segurança e roteiros personalizados do jeitinho que você merece.</p>
          <p className="text-lg text-muted-foreground leading-relaxed">Se você quer uma viagem realmente diferente de tudo que já viveu, a África te espera!</p>
        </section>

        <section className="mb-20">
          <div className="mb-8">
            <h2 className="text-4xl font-bold mb-2 text-primary">África do Sul</h2>
            <p className="text-lg text-muted-foreground">O mais vendido para brasileiros. Destaque para o Parque Nacional Kruger, com ótima estrutura, lodges incríveis e safáris bem organizados. Ideal para primeira viagem.</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <img src={SA_IMAGE_1} alt="Leões na savana" className="w-full h-64 object-cover rounded-lg shadow-lg" />
            <img src={SA_IMAGE_2} alt="Elefantes" className="w-full h-64 object-cover rounded-lg shadow-lg" />
            <img src={SA_IMAGE_3} alt="Girafas ao pôr do sol" className="w-full h-64 object-cover rounded-lg shadow-lg" />
          </div>
        </section>

        <section className="mb-20">
          <div className="mb-8">
            <h2 className="text-4xl font-bold mb-2 text-primary">Tanzânia</h2>
            <p className="text-lg text-muted-foreground">Experiência mais exclusiva e selvagem. Destaques: Serengeti e Ngorongoro, com altíssima concentração de animais e paisagens de tirar o fôlego.</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <img src={TZ_IMAGE_1} alt="Migração de gnus" className="w-full h-64 object-cover rounded-lg shadow-lg" />
            <img src={TZ_IMAGE_2} alt="Leopardo na árvore" className="w-full h-64 object-cover rounded-lg shadow-lg" />
            <img src={TZ_IMAGE_3} alt="Zebras no Ngorongoro" className="w-full h-64 object-cover rounded-lg shadow-lg" />
          </div>
        </section>

        <section className="bg-primary rounded-2xl p-12 text-center text-white shadow-lg">
          <h3 className="text-3xl font-bold mb-4 text-white">Pronto para viver essa experiência?</h3>
          <p className="text-lg mb-8 opacity-90">Entre em contato conosco e vamos criar o safari perfeito para você</p>
          <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-white text-primary hover:bg-gray-100 font-bold py-4 px-12 rounded-full transition-colors text-lg">
            <MessageCircle size={24} />
            Conversar no WhatsApp
          </a>
        </section>
      </div>
      <Footer />
    </div>
  );
}
